import { STORE_LAST_FILTERS_APPLIED, STORE_FILTER_OPTIONS } from '../types';

export const storeLastFiltersApplied = lastFiltersApplied => ({
  type: STORE_LAST_FILTERS_APPLIED,
  payload: lastFiltersApplied,
});

export const storeFilterOptions = (filterCache, lastCacheTime) => ({
  type: STORE_FILTER_OPTIONS,
  filterCache,
  lastCacheTime,
});
